import 'mapbox-gl/dist/mapbox-gl.css';

export const MAP_STYLE_IDS = Object.freeze({
  DEFAULT: 1,
  SATELLITE: 2,
  STREETS: 3,
  DM_STREETS: 4,
});

export const mapStyles = {
  light: 'mapbox://styles/mapbox/light-v9',
  dark: 'mapbox://styles/mapbox/dark-v10',
  dmStreets: 'mapbox://styles/digimondo/cjn4e7kzsjv8w2rlc0a574xu4',
  satellite: 'mapbox://styles/mapbox/satellite-v9',
  streets: 'mapbox://styles/mapbox/streets-v11',
};

export const getSelectedMapStyle = (queryMapStyle, storeMapStyle) =>
  queryMapStyle != null ? queryMapStyle : storeMapStyle != null ? storeMapStyle : MAP_STYLE_IDS.DEFAULT;

export const resolveMapStyle = (mapStyle, isDarkTheme = false) => {
  switch (parseInt(mapStyle, 10)) {
    case MAP_STYLE_IDS.DEFAULT:
      return !isDarkTheme ? mapStyles.light : mapStyles.dark;
    case MAP_STYLE_IDS.SATELLITE:
      return mapStyles.satellite;
    case MAP_STYLE_IDS.STREETS:
      return mapStyles.streets;
    case MAP_STYLE_IDS.DM_STREETS:
      return mapStyles.dmStreets;
    default:
      return !isDarkTheme ? mapStyles.light : mapStyles.dark;
  }
};

export const resolveActiveMapStyle = (queryMapStyle, storeMapStyle, isDarkTheme = false) =>
  resolveMapStyle(getSelectedMapStyle(queryMapStyle, storeMapStyle), isDarkTheme);

export const mapsMixin = {
  methods: {
    getMapStyle(queryMapStyle) {
      return resolveActiveMapStyle(queryMapStyle, this.$store.state.app.mapStyle, this.$store.state.app.UiTheme);
    },
  },
};
